<template>
  <transition name="fade">
    <div
      v-if="navIsVisible"
      class="nav-container flex"
      :class="{ bg_active: navIsWhite }"
    >
      <div class="lg:hidden" @click="$store.commit('toggleMenu')">
        <BaseIcon
          name="times"
          class="cursor-pointer text-xl absolute top-0 right-0 mt-8 mr-8"
        />
      </div>

      <nav class="text-2xl lg:pl-4 lg:text-base lg:flex">
        <div class="nav-link-container" @click="hideMenuAndHideError404()">
          <router-link
            :to="{ name: 'Home', hash: '#main' }"
            class="nav-link nav-link-live font-bold text-red-500 flex justify-center"
          >
            <span class="circle w-5 h-5 bg-red-500 rounded-full"></span>
            <span class="pl-2">Directo</span>
          </router-link>
        </div>

        <div class="nav-link-container" @click="hideMenuAndHideError404()">
          <router-link
            :to="{ name: 'Sessions' }"
            class="nav-link"
            :class="{ 'nav-link-active': $route.name === 'Sessions' }"
          >
            Sesiones
          </router-link>
        </div>

        <div class="nav-link-container" @click="hideMenuAndHideError404()">
          <router-link
            :to="{ name: 'Demos' }"
            class="nav-link"
            :class="{ 'nav-link-active': $route.name === 'Demos' }"
          >
            Demos
          </router-link>
        </div>

        <div class="nav-link-container" @click="hideMenuAndHideError404()">
          <router-link
            :to="{ name: 'Speakers' }"
            class="nav-link"
            :class="{ 'nav-link-active': $route.name === 'Speakers' }"
          >
            Ponentes
          </router-link>
        </div>

        <div class="nav-link-container" @click="hideMenuAndHideError404()">
          <router-link
            :to="{ name: 'Home', hash: '#partners' }"
            class="nav-link"
          >
            Patrocinadores
          </router-link>
        </div>

        <div class="nav-link-container">
          <a
            href="https://concurso-storymaps-2021-marketing.hub.arcgis.com/"
            target="_blank"
            class="nav-link"
          >
            Concurso StoryMaps
          </a>
        </div>

        <div class="nav-link-container">
          <a
            href="https://www.esri.com/es-es/store"
            target="_blank"
            class="nav-link"
          >
            Tienda
          </a>
        </div>

        <div
          v-if="userIsAuthenticated"
          class="nav-link-container"
          @click="hideMenuAndHideError404()"
        >
          <router-link :to="{ name: 'Profile' }" class="nav-link">
            Mi Cuenta
          </router-link>
        </div>

        <div
          v-if="userIsAuthenticated"
          class="nav-link-container"
          @click="hideMenuAndHideError404()"
        >
          <div class="nav-link cursor-pointer" @click="logoutAndRedirect">
            Desconectar
          </div>
        </div>

        <div
          v-if="!userIsAuthenticated"
          class="nav-link-container"
          @click="hideMenuAndHideError404()"
        >
          <router-link :to="{ name: 'Login' }" class="nav-link">
            Acceder
          </router-link>
        </div>

        <div
          v-if="!userIsAuthenticated"
          class="nav-link-container"
          @click="hideMenuAndHideError404()"
        >
          <router-link :to="{ name: 'Register' }" class="nav-link">
            Regístrate
          </router-link>
        </div>
      </nav>
    </div>
  </transition>
</template>

<script>
import resolveConfig from 'tailwindcss/resolveConfig'
import tailwindConfig from '../../tailwind.config'
import { mapState } from 'vuex'
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      windowWidth: '',
    }
  },

  computed: {
    ...mapState(['showMenu', 'menuHidden', 'menuShown']),
    ...mapState('speakers', ['speakersList']),
    ...mapGetters('auth', ['userIsAuthenticated']),

    navIsVisible() {
      return this.windowWidth >= this.windowBreakpoint || this.showMenu
    },

    navIsWhite() {
      return this.windowWidth < this.windowBreakpoint && this.showMenu
    },

    windowBreakpoint() {
      const fullConfig = resolveConfig(tailwindConfig)
      const breakpoint = fullConfig.theme.screens.lg
      return breakpoint.replace('px', '')
    },
  },

  mounted() {
    this.windowWidth = window.innerWidth
    window.addEventListener('resize', () => {
      this.windowWidth = window.innerWidth
    })
  },

  methods: {
    logoutAndRedirect() {
      this.$store.dispatch('auth/logOut').then(() => {
        if (this.$route.name !== 'Home') {
          this.$router.push({ name: 'Home' })
        } else {
          window.location.href = '/'
        }
      })
    },

    hideMenuAndHideError404() {
      this.$store.commit('setShowMenu', false)
      this.$store.commit('setError404', false)
    },
  },
}
</script>

<style scoped>
.bg_active {
  background: white;
}

.nav-container {
  @apply fixed inset-0 flex items-center justify-center;
}

@screen lg {
  .fade-enter-active,
  .fade-leave-active {
    transition: none;
  }

  .nav-container {
    @apply static;
  }

  .nav-link:hover {
    @apply text-main-500;
  }

  .nav-link-live:hover {
    @apply text-red-600;
  }

  .nav-link-live:hover .circle {
    @apply bg-red-600;
  }

  .nav-link-active {
    @apply border-secondary-500;
  }
}
</style>
